<template>
  <div class="container">
    <!-- แสดงเวลาที่สะสม -->
    <div class="card-body" style="text-align:center" v-if="showTime">
      <button type="button" class="btn btn-secondary btn-lg" style="width:100%">
        แสดงเวลาที่ใช้ในการดำเนินกิจกรรม
        <p>{{ formattedTime }} นาที</p>
      </button>
    </div>

    <!-- ปุ่มเริ่มบันทึก -->
    <div v-if="checkWalk">
      <div class="card-body" style="text-align:center" v-if="showCamera">
        <button type="button" v-if="!cameraOn" class="btn btn-success btn-lg" style="width:100%"
          @click="startAndRecord">
          เปิดกล้องมือถือเพื่อทำการบันทึกวิดีโอเวลา 10 วินาทีอัตโนมัติ
        </button>
      </div>
    </div>

    <!-- ปุ่มสิ้นสุดกิจกรรม -->
    <div class="card-body" style="text-align:center" v-if="showFinish">
      <button type="button" class="btn btn-danger btn-lg" style="width:100%" @click="openFinishDialog">
        คลิกที่นี่เมื่อดำเนินกิจกรรมแล้วเสร็จ
      </button>
    </div>

    <div class="card-body" style="text-align:center" v-if="cameraOn || countdownVisible">
    <video ref="preview" autoplay playsinline muted width="320"></video>

    <div v-if="countdownVisible" class="countdown-box">
      กำลังบันทึกวิดีโอ... {{ recordCountdown }} วินาที
    </div>
  </div>

    <!-- popup ถามอาการหลังออกกำลังกาย -->
    <div v-if="showFinishDialog" class="symptom-modal">
      <div class="symptom-modal-content">
        <h4>กรอกอาการหลังออกกำลังกาย</h4>

        <textarea v-model="after_message" class="form-control" rows="4"
          placeholder="เช่น เหนื่อยเล็กน้อย เวียนหัว ปวดขา หายใจไม่สะดวก หรือไม่มีอาการ"></textarea>

        <div style="margin-top: 15px; display:flex; gap:10px; justify-content:center;">
          <button class="btn btn-secondary" @click="closeFinishDialog">ยกเลิก</button>
          <button class="btn btn-primary" @click="confirmFinishAndRecord">ยืนยันและบันทึกวิดีโอ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ParticipantService from "../services/ParticipantService";
import ParticipantsActivitiesService from "../services/ParticipantsActivitiesService";
import ActivitiesService from "../services/ActivitiesService";
import LinkService from "../services/LinkService";
import axios from "axios";

export default {
  name: "Nav",
  components: {
  },
  props: {
    msg: String,
  },
  data() {
    return {
      data: {},
      user: {},
      busy: false,
      cameraOn: false,
      recording: false,
      videoUrl: null,
      stream: null,
      recorder: null,
      chunks: [],
      stopTimerId: null,
      countdownTimerId: null,
      recordCountdown: 10,
      countdownVisible: false,

      showWalk: true,
      seconds: 0,
      timer: null,
      showTime: false,
      showFinish: false,
      showCamera: true,
      showPreview: false,
      walk_per_week: 0,
      walk: {},
      totalSeconds: 120,
      isRunning: false,
      id: 0,
      checkWalk: true,

      showFinishDialog: false,
      targetWalkMinutes: 10,
      todayWalkSeconds: 0,
      after_message: "",
      currentWalkStartedAt: null,
    };
  },
  mounted() {
    // localStorage.removeItem("participants_activity_id");
    const key = "device_id";
    this.id = localStorage.getItem(key);
    this.currentWalkStartedAt = localStorage.getItem("walk_started_at");
    this.getWalk()
    if (this.id) {
      this.getActivity(this.id)
    }
    // console.log(this.id);
    let participants_activity_id = localStorage.getItem("participants_activity_id");
    // console.log(participants_activity_id);

    if (participants_activity_id) {
      this.showFinish = true
      this.showTime = true
      this.showCamera = false
    }

  },
  methods: {
    getTodayWalkSeconds(records) {
      const today = new Date();

      return records.reduce((sum, r) => {
        if (!r.created_at) return sum;

        const d = new Date(r.created_at);
        const isToday =
          d.getFullYear() === today.getFullYear() &&
          d.getMonth() === today.getMonth() &&
          d.getDate() === today.getDate();

        if (!isToday) return sum;

        // ใช้ duration_seconds จาก backend ถ้ามี
        return sum + Number(r.duration_seconds || 0);
      }, 0);
    },

    shouldNotify(activity, records) {
      // console.log(activity, 'activity');
      // console.log(records, 'records');


      const daysOfWeek = JSON.parse(activity.days_of_week);

      const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
      const today = new Date();
      const todayIndex = today.getDay();
      const todayKey = dayMap[todayIndex];
      // console.log(todayKey,'todayKey');


      if (!daysOfWeek[todayKey]) {
        return false;
      }

      const recordList = Array.isArray(records) ? records : [records];

      const todayRecord = recordList.find(r => {
        const recordDate = r.finished_at || r.started_at;
        if (!recordDate) return false;

        const d = new Date(recordDate);
        return (
          d.getFullYear() === today.getFullYear() &&
          d.getMonth() === today.getMonth() &&
          d.getDate() === today.getDate()
        );
      });
      // console.log(todayRecord,'todayRecord');

      // วันนี้มีและ finished แล้ว => false ทันที
      if (todayRecord && todayRecord.finished_at) {
        return false;
      }

      // วันนี้ยังไม่มี หรือยังไม่เสร็จ => true
      return true;
    },
    getLocalDateYMD() {
      return this.formatLocalDateYMD(new Date());
    },

    formatLocalDateYMD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getActivity(id) {
      ParticipantService.get_participant(id).then(
        (response) => {
          if (response.status == 200) {
            this.user = response.data;

            ParticipantService.get_participant_by_imei(this.user.id).then(
              (response) => {
                if (response.status == 200) {
                  const walkRecords = response.data.filter(i => i.activity_id === 1);

                  this.$set(this.user, 'walk', walkRecords);
                  this.$set(this.user, 'round_walk', walkRecords.length + 1);
                  if (this.shouldNotify(this.walk, this.user.walk)) {
                    //  console.log(true);
                    this.checkWalk = true
                  } else {
                    // console.log(false);
                    this.checkWalk = false
                  }
                  // console.log(this.checkWalk,'wak page');
                  
                }
              },
              (error) => {
                console.log(error);
              }
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    openFinishDialog() {
      this.showFinishDialog = true;
    },

    closeFinishDialog() {
      this.showFinishDialog = false;
      this.after_message = "";
    },

    confirmFinishAndRecord() {
  this.showFinishDialog = false;
  this.showTime = false;
  this.showFinish = false

  setTimeout(() => {
    this.startAndRecord();
  }, 300);
},
    startRecordCountdown(durationSec = 10) {
      this.recordCountdown = durationSec;
      this.countdownVisible = true;

      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
      }

      this.countdownTimerId = setInterval(() => {
        if (this.recordCountdown > 0) {
          this.recordCountdown--;
        } else {
          clearInterval(this.countdownTimerId);
          this.countdownTimerId = null;
          this.countdownVisible = false;
        }
      }, 1000);
    },

    stopRecordCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
        this.countdownTimerId = null;
      }
      this.countdownVisible = false;
      this.recordCountdown = 10;
    },
    formatThaiDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('th-TH', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    getWalk() {
      ActivitiesService.getactivity(1).then((res) => {
        this.walk = res.data
        this.walk_per_week = res.data.finish_number_per_week;
        
        
      });
    },
    StartWalk() {
      this.showWalk = false;
    },
    async startAndRecord() {
  if (this.busy) return;
  this.busy = true;

  const isFinishFlow = !!localStorage.getItem("participants_activity_id");

  try {
    if (this.videoUrl) {
      URL.revokeObjectURL(this.videoUrl);
      this.videoUrl = null;
    }

    this.stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "user" },
      audio: true,
    });

    this.cameraOn = true;
    await this.$nextTick();

    if (this.$refs.preview) {
      this.$refs.preview.srcObject = this.stream;
      if (this.$refs.preview.play) {
        await this.$refs.preview.play().catch(() => {});
      }
    }

    this.cameraOn = true;

    const durationSec = 10;

    this.startRecordingNow();
    this.startRecordCountdown(durationSec);

    this.stopTimerId = window.setTimeout(() => {
      this.stopRecording();
      this.stopAll();
    }, durationSec * 1000);

  } catch (err) {
    console.error(err);

    if (isFinishFlow) {
      this.showTime = true;
      this.showFinish = true;
    }

    alert("เปิดกล้อง/อัดวิดีโอไม่ได้ กรุณาอนุญาตกล้องและไมค์");
  } finally {
    this.busy = false;
  }
},
    insertupdateParticipantsActivities(id, fileName, type_walk) {
      if (id != 0) {

        const startedAtValue =
          this.currentWalkStartedAt ||
          localStorage.getItem("walk_started_at");

        if (!startedAtValue) {
          alert("ไม่พบเวลาเริ่มต้นกิจกรรม");
          return;
        }

        const finishedAt = new Date();
        const startedAt = new Date(startedAtValue);

        const durationSeconds = Math.floor((finishedAt - startedAt) / 1000);
        const isSuccess = durationSeconds >= 1200

        // console.log(durationSeconds, 'durationSeconds');
        // console.log(isSuccess, 'isSuccess');
        const messageObj = this.getEncourageMessage(isSuccess).message;
        ParticipantsActivitiesService.updateparticipants_activitie(id, {
          end_record_path: `/uploads/walk/${type_walk}_${fileName}`,
          finished_at: finishedAt,
          duration: durationSeconds,
          is_success: isSuccess,
          after_message: this.after_message,
        }).then(() => {
          // console.log(res.data);

          localStorage.removeItem("participants_activity_id");
          localStorage.removeItem("walk_started_at");
          this.currentWalkStartedAt = null;

          this.showFinish = false;
          this.showTime = false;
          this.showCamera = true;
          this.showPreview = false;
          this.after_message = "";

          clearInterval(this.timer);
          this.timer = null;
          this.seconds = 0;

          this.getActivity(this.id);

          // alert("บันทึกภาพวิดีโอการสิ้นสุดกิจกรรมการเดินสำเร็จ");

          alert(messageObj)
          location.reload();
        }).catch((err) => {
          console.error(err);
        });

        return;
      }

      // start flow
      const startedAt = new Date();

      ParticipantsActivitiesService.create_participants_activitie({
        participant_id: this.user.id,
        activity_id: 1,
        monitoring_number_id: this.user.monitoring_number_id,
        round: this.user.round_walk,
        set_of_activities: 1,
        start_record_path: `/uploads/walk/${type_walk}_${fileName}`,
        started_at: startedAt,
        activity_date: this.getLocalDateYMD(),
      }).then((res) => {
        console.log(res.data);

        localStorage.setItem("participants_activity_id", res.data.id);
        localStorage.setItem("walk_started_at", startedAt.toISOString());
        this.currentWalkStartedAt = startedAt.toISOString();

        if (!this.user.walk) {
          this.$set(this.user, "walk", []);
        }
        this.user.walk.push(res.data);

        this.showFinish = true;
        this.showTime = true;
        this.showCamera = false;
        this.showPreview = false;

        this.seconds = 0;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.seconds++;
        }, 1000);

        alert("บันทึกภาพวิดีโอการเริ่มต้นกิจกรรมการเดินสำเร็จ เริ่มกิจกรรมการเดินได้เลยค่ะ");
      }).catch((err) => {
        console.error(err);
      });
    },
    startRecordingNow() {
      this.showPreview = true
      let participants_activity_id = localStorage.getItem('participants_activity_id');

      if (!this.stream) return;

      this.chunks = [];

      const preferredMime = "video/webm;codecs=vp8,opus";
      let options = {};
      if (window.MediaRecorder && MediaRecorder.isTypeSupported(preferredMime)) {
        options = { mimeType: preferredMime };
      }

      this.recorder = new MediaRecorder(this.stream, options);

      this.recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) this.chunks.push(e.data);
      };

      this.recorder.onstop = async () => {
        const blob = new Blob(this.chunks, {
          type: this.recorder.mimeType || "video/webm",
        });

        this.videoUrl = URL.createObjectURL(blob);

        const fileName = `video_walk_${this.user.id}_${Date.now()}.webm`;

        const formData = new FormData();
        formData.append("file", blob, fileName);
        formData.append("name", fileName);
        var type_walk = 'start'
        try {
          if (participants_activity_id) {
            type_walk = 'finish'
          } else {
            participants_activity_id = 0
          }
          const res = await axios.post(
            LinkService.getLink() + `/uploadvideo?name=walk/${type_walk}_${fileName}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log("Upload success:", res.data);
          this.insertupdateParticipantsActivities(participants_activity_id, fileName, type_walk);

        } catch (err) {
          console.error("Upload error:", err);
        }
      };

      // this.recorder.onstop = () => {
      //   const blob = new Blob(this.chunks, {
      //     type: this.recorder.mimeType || "video/webm",
      //   });
      //   this.videoUrl = URL.createObjectURL(blob);
      //   console.log(this.videoUrl,'videoUrl');

      // };

      this.recorder.start();
      this.recording = true;
    },
    stopRecording() {
      if (this.stopTimerId) {
        clearTimeout(this.stopTimerId);
        this.stopTimerId = null;
      }

      this.stopRecordCountdown();

      if (this.recorder && this.recorder.state !== "inactive") {
        this.recorder.stop();
      }
      this.recording = false;
    },
    getEncourageMessage(isSuccess) {
      const encourageMessages = JSON.parse(this.walk.encourage_message);
      return isSuccess
        ? encourageMessages.find(m => m.no === 2)
        : encourageMessages.find(m => m.no === 1);
    },
    async stopAll() {
      if (this.recording) this.stopRecording();

      if (this.stream) {
        this.stream.getTracks().forEach((t) => t.stop());
        this.stream = null;
      }

      if (this.$refs.preview && this.$refs.preview.srcObject) {
        this.$refs.preview.srcObject = null;
      }

      this.cameraOn = false;
    },
    showTable(id, btn) {

      document.querySelectorAll('.table-content').forEach(el => {
        el.classList.add('hidden');
      });

      document.getElementById(id).classList.remove('hidden');

      document.querySelectorAll('.menu-btn').forEach(b => {
        b.classList.remove('active');
      });

      btn.classList.add('active');
    },
    startCountdown() {
      if (this.isRunning) return;

      this.isRunning = true;
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.isRunning = false;
          alert('หมดเวลา');
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    this.stopAll();
    if (this.videoUrl) URL.revokeObjectURL(this.videoUrl);
    clearInterval(this.timer);
    clearInterval(this.countdownTimerId);
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    minutes() {
      return Math.floor(this.seconds / 60)
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    formattedTime() {
      const m = Math.floor(this.seconds / 60)
      const s = this.seconds % 60
      return m + ":" + String(s).padStart(2, "0")
    },
    timeLeft() {
      const minutes = Math.floor(this.totalSeconds / 60);
      const seconds = this.totalSeconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  },
}
</script>

<style scoped>
.orangeCell {
  background: orange;
}

.countdown-box {
  margin-top: 12px;
  font-size: 22px;
  font-weight: bold;
  color: #dc3545;
}

.symptom-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.symptom-modal-content {
  background: #fff;
  width: 90%;
  max-width: 500px;
  border-radius: 12px;
  padding: 20px;
}
</style>
